import { render, staticRenderFns } from "./contentVideo2.vue?vue&type=template&id=bf5ea560&scoped=true&"
import script from "./contentVideo2.vue?vue&type=script&lang=js&"
export * from "./contentVideo2.vue?vue&type=script&lang=js&"
import style0 from "./contentVideo2.vue?vue&type=style&index=0&id=bf5ea560&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5ea560",
  null
  
)

export default component.exports